// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'
import mock from '../../../services/mock'

/* istanbul ignore next  */
mock.onPost('/apps/orders/return-order').reply(config => {
    // eslint-disable-next-line object-curly-newline
    return [
        200,
        {
            response: true
        }
    ]
})
export const returnOrder = createAsyncThunk('orders/returnOrder', async (params, { dispatch, getState }) => {
    let result = await axios.post('/apps/orders/return-order', params)
    return result.data.response
})

/* istanbul ignore next  */
mock.onPost('/apps/orders/cancel-order').reply(config => {
    // eslint-disable-next-line object-curly-newline
    return [
        200,
        {
            response: true
        }
    ]
})
export const cancelOrder = createAsyncThunk('orders/cancelOrder', async (params, { dispatch, getState }) => {
    let result = await axios.post('/apps/orders/cancel-order', params)
    return result.data.response
})

export const declinePaymentMethod = createAsyncThunk('orders/declinePaymentMethod', async (orderId, { dispatch, getState }) => {
    let result = await axios.post('/apps/orders/decline-paymentMethod', orderId)
    return result.data.response
})

export const aceptPaymentMethod = createAsyncThunk('orders/aceptPaymentMethod', async (orderId, { dispatch, getState }) => {
    let result = await axios.post('/apps/orders/acept-paymentMethod', orderId)
    return result.data.response
})

/* istanbul ignore next  */
mock.onPost('/apps/orders/send-evidence').reply(config => {
    // eslint-disable-next-line object-curly-newline
    return [
        200,
        {
            response: true
        }
    ]
})
export const sendEvidence = createAsyncThunk('orders/sendEvidence', async (params, { dispatch, getState }) => {
    let result = await axios.post('/apps/orders/send-evidence', params)
    return result.data.response
})


export const detailOrdersSlice = createSlice({
    name: 'detailOrders',
    initialState: {},
    reducers: {}
})

export default detailOrdersSlice.reducer
